import PayChart from './PayChart'

export default PayChart
